'use client';
import { Suspense } from 'react';
import {
  useProduct,
  useSelectedVariant,
  useBundleSelection
} from '@/components/product/product-context';
import {
  findBundleProductImageCollection,
  findVariantImageCollection,
  getDefaultImageCollection
} from '@/utils/resolveImageCollection';
import GalleryView from './GalleryView';
import GallerySkeleton from './GallerySkeleton';

/**
 * The main PDP gallery component. It suspends with a skeleton set to the
 * default image collection, then resolves the actual collection based on the
 * selected variant and options.
 */
export default function ProductGallery({ images }) {
  const imageCollections = images?.image_collections;
  const defaultCollection = getDefaultImageCollection(imageCollections);

  return (
    <div className="pdp-gallery min-h-0 min-w-0 self-start md:mx-0 md:px-10 lg:sticky lg:top-20 lg:px-0">
      <Suspense fallback={<GallerySkeleton collection={defaultCollection} />}>
        <ResolvedProductGallery
          imageCollections={imageCollections}
          defaultCollection={defaultCollection}
        />
      </Suspense>
    </div>
  );
}

function ResolvedProductGallery({ imageCollections, defaultCollection }) {
  const { isBundlePage } = useProduct();
  const { selectedOptions, variant } = useSelectedVariant();
  const bundleState = useBundleSelection();
  const { selectedProduct } = bundleState || {};

  const resolvedCollection =
    isBundlePage && selectedProduct
      ? findBundleProductImageCollection(imageCollections, selectedProduct)
      : findVariantImageCollection(imageCollections, variant, selectedOptions);

  return <GalleryView collection={resolvedCollection || defaultCollection} />;
}
